import { Variant } from '@amplitude/experiment-js-client';

import { AppConfig } from '@wetransfer/transfer/core-bundle/config/app-config';
import { getIsInitialised } from '@wetransfer/transfer/modules/analytics/vendors/amplitude';
import { getFullVariant } from '@wetransfer/transfer/modules/experiments';

export interface PAYLOAD_PROPS {
  campaignTitle: string;
  endDate: Date;
  percentageDiscount: number;
  startDate: Date;
}

const fallbackPayload = [
  {
    endDate: 'Mon, 28 Nov 2022 04:59:59 UTC',
    startDate: 'Fri, 25 Nov 2022 05:00:00 UTC',
    couponCode: 'NOONEREADSTHIS',
    campaignTitle: 'Black Friday',
    percentageDiscount: 50,
  },
  {
    endDate: 'Tue, 29 Nov 2022 04:59:59 UTC',
    startDate: 'Mon, 28 Nov 2022 05:00:00 UTC',
    couponCode: 'NOONEREADSTHIS',
    campaignTitle: 'Cyber Monday',
    percentageDiscount: 50,
  },
  {
    endDate: 'Fri, 02 Dec 2022 04:59:59 UTC',
    startDate: 'Wed, 30 Nov 2022 05:00:00 UTC',
    couponCode: 'NOONEREADSTHIS',
    campaignTitle: 'Cyber Monday',
    percentageDiscount: 50,
  },
  {
    endDate: 'Sat, 03 Dec 2022 09:59:59 UTC',
    startDate: 'Fri, 02 Dec 2022 05:00:00 UTC',
    couponCode: 'NOONEREADSTHIS',
    campaignTitle: 'Last Chance',
    percentageDiscount: 50,
  },
];

export default class ExperimentDiscountBanner {
  static key = 'discount-banner';

  static variations = {
    control: 'control',
    'show-discount-banner': 'discount-banner',
  };

  static isControl(): boolean {
    return this.currentVariant() === this.variations.control;
  }

  static isShowDiscountBanner(): boolean {
    return this.currentVariant() === this.variations['show-discount-banner'];
  }

  static payload: PAYLOAD_PROPS[] = null;

  static currentVariant(): string {
    const amplitudeUser = AppConfig.amplitude.user;

    let fallback: Variant = { value: this.variations['control'] };

    if (amplitudeUser && amplitudeUser.country === 'US') {
      fallback = {
        value: this.variations['show-discount-banner'],
        payload: fallbackPayload,
      };
    }

    const { payload, value } = getFullVariant(this.key, fallback);
    this.payload = payload;

    return value;
  }

  static isInitialised(): boolean {
    return getIsInitialised();
  }
}
